

















import {Component, Vue} from 'vue-property-decorator';
import TableRoute from '@c/tables/TableRoute.vue';
import {Can} from '@casl/vue';
import {BearingTasksTableHeader} from './interfaces';
import bearingtasksStoreModule from '@/store/modules/bearingtasksModule';

@Component({
  components: {
    TableRoute,
    Can,
  },
})
export default class BearingTasksView extends Vue {
  headers: BearingTasksTableHeader[] = [
    {
      text: 'Название',
      value: 'name',
      sortable: true,
    },
    {
      text: 'Описание',
      value: 'description',
      sortable: false,
    },
  ];

  get apiStore() {
    return bearingtasksStoreModule;
  }
}
